export const educationData = [
    {
        id: 1,
        institution: 'Amity University, Noida',
        course: 'Master of Computer Application',
        startYear: 'july, 2023',
        endYear: 'Present',
        image: 'https://raw.githubusercontent.com/CoderAnnu/personal-assets/master/Education/amity-transparent-new.png'

    },
    {
        id: 2,
        institution: 'IGNOU University, Delhi',
        course: 'Bachelor of Computer Application',
        startYear: 'july, 2016',
        endYear: 'Dec, 2019',
        image: 'https://raw.githubusercontent.com/CoderAnnu/personal-assets/master/Education/ignou_image.png'

    },
    {
        id: 3,
        institution: 'Indian Institue of Computer Science, Delhi',
        course: 'Advance Diploma in Computer Engineering',
        startYear: 'March, 2016',
        endYear: 'Dec, 2018',
        image: 'https://raw.githubusercontent.com/CoderAnnu/personal-assets/master/Education/IICS_image.png'


    },
    {
        id: 4,
        institution: 'Indian Institue of Computer Science, Delhi',
        course: 'Web Development',
        startYear: 'Sept, 2017',
        endYear: 'march, 2018',
        image: 'https://raw.githubusercontent.com/CoderAnnu/personal-assets/master/Education/IICS_image.png'

    },
]